import { render, staticRenderFns } from "./LEDPCBAlice.vue?vue&type=template&id=40907754&scoped=true&"
import script from "./LEDPCBAlice.vue?vue&type=script&lang=js&"
export * from "./LEDPCBAlice.vue?vue&type=script&lang=js&"
import style0 from "./LEDPCBAlice.vue?vue&type=style&index=0&id=40907754&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40907754",
  null
  
)

export default component.exports